module.exports = __webpack_public_path__ + "img/bigright1.c0f15eab.svg";